import { Component, computed, input } from '@angular/core';

export const mapping = {
  'last-chance': {
    mode: 'warning',
    title: 'Last chance to edit your booking',
    copy: 'After this page, you won’t be able to change what you’ve entered so far.',
    link: '',
    linkLabel: 'Check your booking',
    icon: 'fa-circle-exclamation',
  },
};

type Mapping = typeof mapping;
type MappingVariant = keyof Mapping;

@Component({
  selector: 'app-info-box',
  standalone: true,
  templateUrl: './info-box.component.html',
  styleUrl: './info-box.component.scss',
})
export class InfoBoxComponent {
  variant = input.required<MappingVariant>();

  private viewModel = computed((): Mapping[MappingVariant] => mapping[this.variant()]);

  get vm() {
    return this.viewModel();
  }
}
